/**
 * Sentry initialization - must be imported first in main.tsx
 * Override with VITE_SENTRY_DSN in .env if needed.
 */
import * as Sentry from '@sentry/react';

const dsn =
  import.meta.env.VITE_SENTRY_DSN ||
  'https://931dc5b2e5e53a2a0de1592b9c2bc21d@o4510832867672064.ingest.de.sentry.io/4510832872128592';

/** Capture memory stats when available (Chrome). Helps diagnose OOM crashes. */
function getMemoryContext(): Record<string, unknown> | null {
  try {
    const perf = performance as Performance & { memory?: { usedJSHeapSize: number; totalJSHeapSize: number; jsHeapSizeLimit: number } };
    if (perf?.memory) {
      return {
        usedJSHeapSizeMB: Math.round(perf.memory.usedJSHeapSize / 1024 / 1024),
        totalJSHeapSizeMB: Math.round(perf.memory.totalJSHeapSize / 1024 / 1024),
        jsHeapSizeLimitMB: Math.round(perf.memory.jsHeapSizeLimit / 1024 / 1024),
      };
    }
  } catch {
    // performance.memory is Chrome-only
  }
  return null;
}

Sentry.init({
  dsn,
  sendDefaultPii: true,
  beforeSend(event, hint) {
    const mem = getMemoryContext();
    if (mem) {
      event.contexts = event.contexts || {};
      event.contexts.memory = mem;
    }
    return event;
  },
});
